import React, { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from 'src/components';

import { ROUTE } from 'src/constants/routes';

import { ArrowRightBottomIcon, DefaultBlot, EnterIcon, LightEllipse } from 'src/assets';
import { ComputerGraph } from 'src/assets/pages/tradingSessions';
import './financeWorld.scss';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const FinanceWorld = () => {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const onNavigate = useCallback(
    (to) => () => {
      navigate(to?.replace(':language', i18n.language));
    },
    [i18n.language, navigate],
  );

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="finance-world">
      <div className={`finance-world-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="finance-world-title">
          <h1>
            {t('financeWorld:be')} <blue-underline>{t('financeWorld:step')}</blue-underline>
            <br />
            <blue-text>{t('financeWorld:finances')}</blue-text>
            <br />
            {t('financeWorld:platform')}
          </h1>
          <text>{t('financeWorld:subtitle')}</text>
          <div className="finance-world-button">
            <Button
              onClick={onNavigate(ROUTE.AUTH.SIGNIN)}
              title={t('title:createWallet')}
              icon={ArrowRightBottomIcon}
            />
            <Button
              onClick={onNavigate(ROUTE.AUTH.SIGNUP)}
              title={t('title:register')}
              icon={EnterIcon}
              color="white"
            />
          </div>
        </div>
        <div className="finance-world-image">
          <img src={DefaultBlot} alt={DefaultBlot} className="finance-world-image-1" />
          <img src={ComputerGraph} alt={ComputerGraph} className="finance-world-image-2" />
        </div>
        <img src={LightEllipse} alt={LightEllipse} className="finance-world-image-3" />
      </div>
    </div>
  );
};
